import { Avatar } from 'avatar-components/Avatar';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { Media, MediaBody, MediaLeft } from 'foundations-components/transitional/components/Media';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const socialMediaNamesMap = {
  x: 'X',
  linkedin: 'LinkedIn'
};
const SocialLink = ({
  type,
  url
}) => {
  return url ? /*#__PURE__*/_jsx(Link, {
    external: true,
    href: url,
    children: socialMediaNamesMap[type]
  }) : null;
};
const ProfessorRow = ({
  id,
  name,
  description,
  image,
  xUrl,
  linkedinUrl,
  jobTitle,
  organisation,
  organisationUrl,
  handleOrganisationUrlClick
}) => {
  return /*#__PURE__*/_jsxs(Media, {
    children: [/*#__PURE__*/_jsx(MediaLeft, {
      children: /*#__PURE__*/_jsx(Avatar, {
        displayName: name,
        size: "lg",
        src: image
      })
    }), /*#__PURE__*/_jsxs(MediaBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        marginBlockEnd: "0",
        children: name
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        marginBlockEnd: "0",
        children: jobTitle
      }), organisationUrl && organisation ? /*#__PURE__*/_jsx(Link, {
        external: true,
        href: organisationUrl,
        onClick: handleOrganisationUrlClick(id, organisation, organisationUrl),
        children: organisation
      }) : /*#__PURE__*/_jsx("p", {
        children: organisation
      }), /*#__PURE__*/_jsx("p", {
        children: description
      }), /*#__PURE__*/_jsx(SocialLink, {
        type: "x",
        url: xUrl
      }), /*#__PURE__*/_jsx(SocialLink, {
        type: "linkedin",
        url: linkedinUrl
      })]
    })]
  });
};
export default ProfessorRow;